module.exports = __webpack_public_path__ + "static/media/tulus-success-story-quote.a69fc6fe.png";